/**
 * Скролим к элементу, заданному в атрибуте data-scroll-to.
 * @param {string|HTMLElement|jQuery} $targetOrSelector
 * @param options
 * @param callback
 */
export default function scrollToElement ($targetOrSelector, options = {}, callback = () => {}) {
	let $target = $($targetOrSelector);
	if (!$target.length) {
		console.warn(`Target ${$targetOrSelector} was not found`);
		return false;
	}
	let {
		speed = 2000
	} = options;
	// let headerHeight = $('.header').outerHeight();
	let scrollTop = $(window).scrollTop();
	let destination = $target.offset().top - 30; // - headerHeight;
	destination = destination < 0 ? 0 : destination;
	let delta = Math.abs(destination - scrollTop);
	let duration = delta / speed * 1000;
	$('html, body').stop().animate({
		scrollTop: destination
	}, {
		duration: duration,
		done: callback
	});
	return false;
}



// WEBPACK FOOTER //
// ./_HTML/src/js/_modules/scrollToElement.js